import { TextProps } from '@chakra-ui/react';

const invitedBySecondarySx: TextProps = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: 'textSubdued',
  fontSize: 'xs',
};

const nameSecondarySx: TextProps = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: 'textSubdued',
  fontSize: 'sm',
};

export { invitedBySecondarySx, nameSecondarySx };
